// Libraries
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../config/screen';

export const TableContainer = styled.div`
  padding-top: 1.75rem;
  overflow-x: hidden;

  .date-column {
    padding-right: 1rem !important;
    .ant-table-column-sorters {
      justify-content: flex-end;
    };
  };
`;

export const NavigationTabsContainer = styled.div`
  margin-left: 1rem;

  // Remove margin for larger screens
  @media (min-width: ${BREAKPOINTS.sm}px) {
    margin-left: 0;
  };
`;
